import React from "react";
import DeviceEditForm from "./components/DeviceEditForm";
import Layout from "components/Layout";

function AdminDeviceEditPage() {
  return (
    <Layout title="장치 수정/삭제">
      <DeviceEditForm />
    </Layout>
  );
}

export default AdminDeviceEditPage;
